import { getApiBaseUrl } from '../../../utils/apiConfig';

const API_BASE_URL = getApiBaseUrl();

function authHeaders() {
  const token = localStorage.getItem('authToken');
  return {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  };
}

async function parseJson(res) {
  try {
    return await res.json();
  } catch {
    return { success: false, message: 'Resposta inválida do servidor' };
  }
}

/** Lista formas de cobrança. Por padrão só ativas. */
export async function fetchGoMeters({ includeInactive = false } = {}) {
  const q = includeInactive ? '?includeInactive=1' : '';
  const res = await fetch(`${API_BASE_URL}/api/config/go/meters${q}`, {
    headers: authHeaders(),
  });
  const result = await parseJson(res);
  if (!res.ok || !result.success) {
    throw new Error(result.message || 'Erro ao carregar formas de cobrança');
  }
  return result.data || [];
}

/** Cria forma de cobrança. */
export async function createGoMeter({ nome, unit, requiresPrevMeter, erpEnabled, erpOps }) {
  const res = await fetch(`${API_BASE_URL}/api/config/go/meters`, {
    method: 'POST',
    headers: authHeaders(),
    body: JSON.stringify({ nome, unit, requiresPrevMeter, erpEnabled, erpOps }),
  });
  const result = await parseJson(res);
  if (!res.ok || !result.success) {
    throw new Error(result.message || 'Erro ao criar forma de cobrança');
  }
  return result.data;
}

/** Atualiza forma de cobrança. */
export async function updateGoMeter(id, { nome, unit, requiresPrevMeter, erpEnabled, erpOps, isActive }) {
  const res = await fetch(`${API_BASE_URL}/api/config/go/meters/${id}`, {
    method: 'PUT',
    headers: authHeaders(),
    body: JSON.stringify({ nome, unit, requiresPrevMeter, erpEnabled, erpOps, isActive }),
  });
  const result = await parseJson(res);
  if (!res.ok || !result.success) {
    throw new Error(result.message || 'Erro ao atualizar forma de cobrança');
  }
  return result.data;
}

/** Catálogo de equipamentos serializados em parque (por tecnologia / fabricante). */
export async function fetchGoMeterEquipmentCatalog() {
  const res = await fetch(`${API_BASE_URL}/api/config/go/meters/equipment-catalog`, {
    headers: authHeaders(),
  });
  const result = await parseJson(res);
  if (!res.ok || !result.success) {
    throw new Error(result.message || 'Erro ao carregar modelos de equipamento');
  }
  return result.data || [];
}

/**
 * Substitui vínculos de equipamentos da forma (1 código = 1 equipamento).
 * @param {number|string} id
 * @param {{ equipmentCode: string, idBrand: string, idSubgroup: string }[]} items
 */
export async function putGoMeterTechLinks(id, items) {
  const res = await fetch(`${API_BASE_URL}/api/config/go/meters/${id}/tech-links`, {
    method: 'PUT',
    headers: authHeaders(),
    body: JSON.stringify({ items }),
  });
  const result = await parseJson(res);
  if (!res.ok || !result.success) {
    throw new Error(result.message || 'Erro ao salvar vínculos de modelos');
  }
  return result.data;
}

/** Busca grupos de cobrança (mín. 2 caracteres). */
export async function searchGoMeterCollectionsGroups(q) {
  const term = String(q || '').trim();
  if (term.length < 2) return [];
  const res = await fetch(
    `${API_BASE_URL}/api/config/go/meters/collections-groups?q=${encodeURIComponent(term)}`,
    { headers: authHeaders() }
  );
  const result = await parseJson(res);
  if (!res.ok || !result.success) {
    throw new Error(result.message || 'Erro ao buscar grupos de cobrança');
  }
  return result.data || [];
}

/**
 * Substitui vínculos de grupos de cobrança da forma.
 * Cada item = equipamento dentro do grupo.
 * @param {number|string} id
 * @param {{ idCollectionsGroup: string, equipmentCode: string }[]} items
 */
export async function putGoMeterGrpLinks(id, items) {
  const res = await fetch(`${API_BASE_URL}/api/config/go/meters/${id}/grp-links`, {
    method: 'PUT',
    headers: authHeaders(),
    body: JSON.stringify({ items }),
  });
  const result = await parseJson(res);
  if (!res.ok || !result.success) {
    throw new Error(result.message || 'Erro ao salvar vínculos de grupos');
  }
  return result.data;
}
